import { render, staticRenderFns } from "./AdminSubscription.vue?vue&type=template&id=a70d83ac&scoped=true"
import script from "./AdminSubscription.vue?vue&type=script&lang=js"
export * from "./AdminSubscription.vue?vue&type=script&lang=js"
import style0 from "./AdminSubscription.vue?vue&type=style&index=0&id=a70d83ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70d83ac",
  null
  
)

export default component.exports